import { render, staticRenderFns } from "./NyBalls.vue?vue&type=template&id=c1e6637e&scoped=true"
import script from "./NyBalls.vue?vue&type=script&lang=js"
export * from "./NyBalls.vue?vue&type=script&lang=js"
import style0 from "./NyBalls.vue?vue&type=style&index=0&id=c1e6637e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1e6637e",
  null
  
)

export default component.exports